export default "__VITE_PUBLIC_ASSET__26601f71__"